<template>
  <c-app>
    <c-content>
      <section class="message u-m-auto">
        <div class="message__media">
          <h1 class="u-fs-128">404</h1>
        </div>
        <p class="message__title">OOPS!</p>
        <p class="message__content">
          ¡Lo sentimos! La página que estás buscando no existe.
        </p>
        <c-button type="primary" size="lg" @click.prevent="goHome" smart>Ir al inicio</c-button>
      </section>
    </c-content>
  </c-app>
</template>

<script>
  export default {
    name: 'ErrorView',
    data () {
      return {
        user: {}
      }
    },
    methods: {
      goHome() {
        const vm = this         
        if (vm.user.profile.name == 'Consultor') {
          vm.$router.push({ path: '/consultor' })              
        } else {
          vm.$router.push({ path: '/home' })
        }
      }
    },
    mounted() {
      const vm = this
      vm.user = vm.$store.getters['auth/getUserInfo']
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/error.vue